export const messages = {
  labels: {
    tumorMarkerDate: {
      id: 'treatmentSummary.Groups.TumorMarker.TumorMarkerDate',
      defaultMessage: 'Date: ',
    },
    testResult: {
      id: 'treatmentSummary.Groups.TumorMarker.TestResult',
      defaultMessage: 'Summary: ',
    },
    providerName: {
      id: 'treatmentSummary.Groups.TumorMarker.ProviderName',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.TumorMarker.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.TumorMarker.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.TumorMarker.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.TumorMarker.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
